import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import { graphql } from '../../__generated__';
import { showErrorToast, showSuccessToast } from '../../Common/utils/toast';

export const useDoctorAppointmentCancel = (
  requestID: string | undefined,
  onCancel?: () => void,
) => {
  const [showModal, setShowModal] = useState(false);

  const [cancelAppointmentMutation, { loading }] = useMutation(
    graphql(`
      mutation cancelDoctorAppointment($id: String, $notes: String, $type: String) {
        cancelDoctorAppointment(id: $id, notes: $notes, type: $type) {
          __typename
          id
          appointment {
            __typename
            id
            date
            confirmed
            cancelled
            userId
          }
        }
      }
    `),
  );

  const [type, setType] = useState<null | 'cancel' | 'park' | 'noshow'>(null);

  const [notes, setNotes] = useState<string>('');

  const canSubmit = notes && notes?.length > 1 && type && type?.length > 1;

  useEffect(() => {
    setShowModal(false);
    setType(null);
    setNotes('');
  }, [requestID]);

  const cancelAppointment = async () => {
    if (!canSubmit) return;

    const { errors } = await cancelAppointmentMutation({
      variables: {
        id: requestID,
        notes,
        type,
      },
    });

    if (errors) {
      showErrorToast('Error occurred while canceling appointment');

      return;
    }

    setShowModal(false);

    showSuccessToast('Appointment cancelled');

    if (onCancel) {
      onCancel();
    }
  };

  return {
    canSubmit,
    cancelAppointment,
    setShowModal,
    showModal,
    loading,
    setType,
    type,
    notes,
    setNotes,
  };
};
